/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from '../../Common/reactstrap/lib';

 const ModalCreditLimit = (props) =>   (
        <Modal isOpen={props.isOpen} toggle={props.toggle} className='modal-small'>
          <ModalHeader toggle={props.toggle}>Не хватает средств для заказа</ModalHeader>
          <ModalBody>
            <div>
              <div className="mt-4 mb-4">Пополните ваш баланс или обратитесь к менеджерам</div>
              <div className="mb-3">
                <p>+7 (495) 649 62 53</p>
                <p>order@qq.ru</p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={props.toggle}>Понятно</Button>
          </ModalFooter>
        </Modal>
    );

export default ModalCreditLimit;





/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/ModalCreditLimit.jsx
 **/